import React from 'react'
import Gallery01 from '../assets/images/Gallery01.png'
import Gallery02 from '../assets/images/Gallery02.png'
import Gallery03 from '../assets/images/Gallery03.png'
import Gallery04 from '../assets/images/Gallery04.png'
import Gallery05 from '../assets/images/Gallery05.png'

export const OurGalleryImagesSec = () => {
  return (
    <div className="OurGalleryImages">
      <div className="container">
        <div className="row">
            <div className="col-lg-6 col-sm-12">
                <img src={Gallery05} alt="Gallery05" />
            </div>
            <div className="col-lg-6 col-sm-12">
                <div className="row padd">
                    <div className="col-lg-6 col-sm-6"><img src={Gallery04} alt="Gallery04" /></div>
                    <div className="col-lg-6 col-sm-6"><img src={Gallery02} alt="Gallery02" /></div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-sm-6"><img src={Gallery03} alt="Gallery03" /></div>
                    <div className="col-lg-6 col-sm-6"><img src={Gallery01} alt="Gallery01" /></div>
                </div>
            </div>
        </div>
      </div>

    </div>
  )
}
